import { useEffect } from "react";
import { PoisonTool } from "@/components/PoisonTool";
import { VerifyTool } from "@/components/VerifyTool";
import { Donate } from "@/components/Donate";

const Section = ({ kicker, title, children }) => (
  <section className="mb-16">
    <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#70250a] mb-3">{kicker}</p>
    <h2 className="font-cinzel font-bold text-2xl sm:text-3xl text-[#E6E2D6] uppercase tracking-tight mb-8">{title}</h2>
    {children}
  </section>
);

const Embed = () => {
  useEffect(() => {
    if (window.self === window.top) return; // only when embedded in an iframe
    let last = 0;
    const post = () => {
      const h = Math.ceil(document.documentElement.scrollHeight);
      if (h && h !== last) {
        last = h;
        window.parent.postMessage({ type: "inkshroud-height", height: h }, "*");
      }
    };
    post();
    const ro = new ResizeObserver(post);
    ro.observe(document.body);
    window.addEventListener("load", post);
    const id = setInterval(post, 1200);
    return () => { ro.disconnect(); window.removeEventListener("load", post); clearInterval(id); };
  }, []);

  return (
    <div className="bg-[#0b1413] px-4 py-8 sm:px-6" data-testid="embed-page">
      <div className="max-w-5xl mx-auto">
        <Section kicker="Shroud" title="Protect a manuscript">
          <PoisonTool />
        </Section>

        <div className="border-t border-[#485354]/25 pt-14">
          <Section kicker="Proof of protection" title="Verify the shrouding">
            <VerifyTool />
          </Section>
        </div>

        <div className="border-t border-[#485354]/25 pt-14">
          <Donate />
        </div>
      </div>
    </div>
  );
};

export default Embed;
